import CloseIcon from "@mui/icons-material/CloseRounded";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const DialogTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
}));

const IconButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "1.875rem",
  height: "1.875rem",
  borderRadius: "100%",
  background: theme.palette.grey[200],
  color: theme.palette.text.primary,
  border: "0px",
  cursor: "pointer",
  "&:hover": {
    background: theme.palette.grey[300],
    // color: theme.palette.common.white,
  },
}));

type Props = {
  title: string;
  startAction?: any;
  onClose: () => void;
  border?: boolean;
};

export default function BootstrapDialogTitle(props: Props) {
  const { title, startAction, onClose, border = false } = props;

  return (
    <DialogTitle
      sx={Object.assign(
        border && {
          borderBottom: "1px solid",
          borderBottomColor: "grey.300",
        }
      )}
    >
      <React.Fragment>
        {startAction}
        <Typography variant="h6" sx={{ flex: 1 }}>
          {title}
        </Typography>
      </React.Fragment>
      <IconButton aria-label="close" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
}
